module.exports = __webpack_public_path__ + "img/android_qr.8a70795e.png";